<template>
	<pre v-html="$t('terms.agreement2')"></pre>
</template>

<script>
export default {
	name: 'Agreement2',
};
</script>

<style scoped></style>
